// Authentication is read directly from session cookies, never mirrored into storage.
const authKeys = [
  'user_id', 'access_token', 'id_token', 'expires_in', 'mfa_required',
  'mfa_passed', 'mfa_expiry', 'mfa_email_sent', 'sadm', 'lac'
];

// Match the server's shared cookie scope in production and staging.
// Local development and other hosts keep host-only cookies.
const sharedDomain = ['qunote3.net', 'qunotetestsuite.com'].find(domain =>
  location.hostname === domain || location.hostname.endsWith('.' + domain));
const cookieDomain = sharedDomain ? '; Domain=.' + sharedDomain : '';
const cookieAttributes = '; Path=/' + cookieDomain;

// Remove data left by previous versions, without trusting or migrating it.
try {
  authKeys.forEach(key => window.localStorage.removeItem(key));
} catch (_) {
  // Storage can be disabled by browser policy; cookies still work.
}

export const sessionState = {
  getItem(key: string): string | null {
    if (authKeys.indexOf(key) === -1) {
      return null;
    }
    const prefix = encodeURIComponent(key) + '=';
    const cookie = document.cookie.split(';').map(value => value.trim())
      .find(value => value.startsWith(prefix));
    if (!cookie) return null;
    try {
      return decodeURIComponent(cookie.slice(prefix.length));
    } catch (_) {
      return null;
    }
  },
  setItem(key: string, value: any): void {
    if (authKeys.indexOf(key) === -1) {
      return;
    }
    document.cookie = encodeURIComponent(key) + '=' + encodeURIComponent(String(value))
      + cookieAttributes;
  },
  removeItem(key: string): void {
    if (authKeys.indexOf(key) !== -1) {
      document.cookie = encodeURIComponent(key) + '=; Max-Age=0' + cookieAttributes;
    }
  },
  clear(): void {
    console.log(authKeys);
    authKeys.forEach(key => this.removeItem(key));
    localStorage.clear();
    console.log('Cleared session state');
  }
};
